import React, { Component } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import * as url from '../../utils/url';
import axios from '../../axios';
import NotificationItem from '../../components/Notifications/NotificationItem/NotificationItem';
import Notifications from '../../components/Notifications/Notifications';
import './Notifications.css';
import Spinner from '../../assets/spinner.gif';
import { connect } from 'react-redux';
import * as actionCreators from '../../modules/actions/index';
import {withRouter} from 'react-router-dom';
import { isMobile } from '../../utils/deviceInfo';

class Notification extends Component {
    constructor(props) {
      super(props);
    }

    componentDidMount(){
      if(isMobile)
        this.props.updateNavBar({
          title: "Notifications",
          hasBack: true,
          backButton: '<b>Back</b>',
          showNotification: true,
          className: null,
          isBreadCrumbs: false
        });
  }

    handleUnreadCountChanged = (unreadNotifications) => {
      // console.log(unreadNotifications)
      this.props.updateNavBar({ unreadNotifications});
    }

  render() {
    return (
      <div>
        <Notifications
          {...this.props}
          notificationOpen={true}
          onUnreadCountChanged={this.handleUnreadCountChanged}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
	return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header))
	}
}

const mapStateToProps = state => {
  return {
    navBar: state.navBar,
    user: state.user.profile,
  };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notification));
